import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, map, retry } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { ApiEnum, HttpDataService } from "./http-data.service";
import { CebesCentrosViewModel } from "../models/centros/centro-list-base.model";

/** Lookup mínimo de contrato para CONTEXTO (id/código/descripción/país). Sin scoping por usuario. */
export interface ContratoLookup {
	id: number;
	codigo: string;
	descripcion: string;
	/** País del contrato — fallback del país del centro cuando no hay CeBe vinculado. */
	paisId?: number | null;
}

@Injectable({
	providedIn: "root",
})
export class CebesCentrosService {
	constructor(private readonly httpDataService: HttpDataService) {}

	/**
	 * Contrato padre de un centro (info básica). Endpoint de contexto NO scopeado: quien tiene
	 * acceso al centro recupera el contrato aunque éste no esté en su alcance. Sin retry: un
	 * 404 aquí es definitivo (contrato inexistente/borrado), no transitorio.
	 */
	getContratoLookupById(contratoId: number): Observable<ContratoLookup> {
		return this.httpDataService
			.get$<ContratoLookup>(
				ApiEnum.API_ROOT,
				`${environment.endpoint.contratos.lookupById}/${contratoId}`
			)
			.pipe(
				catchError(
					this.httpDataService.handleError<ContratoLookup>(
						"getContratoLookupById"
					)
				)
			);
	}

	getContratoCentroByCentro(id: number): Observable<CebesCentrosViewModel> {
		return this.httpDataService
			.get$<CebesCentrosViewModel>(
				ApiEnum.API_ROOT,
				`${environment.endpoint.centros.getContratoCentroByCentro}/${id}`
			)
			.pipe(
				map((cebeCentro) => {
					return cebeCentro;
				}),
				retry(3),
				catchError(
					this.httpDataService.handleError<CebesCentrosViewModel>(
						"getContratoCentroByCentro"
					)
				)
			);
	}
}
